import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import ReactDataGrid from 'react-data-grid';
import { Data, Toolbar } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import Dropzone from 'react-dropzone';
import { Button, ButtonToolbar, Row, Col } from 'react-bootstrap';

import { getProductPdfs, uploadPdf, saveProductPdfs } from '../../../actions/products_actions';
import { RowRenderer } from '../../Common/rowRenderer';
import { PRODUCTS_URL } from '../../../actions/url';
import SpinnerButton from '../../Common/SpinnerButton';
import Spinner from '../../../components/Widgets/spinner';

const propTypes = {
};

const defaultProps = {
};

const PdfFormatter = React.createClass({
  render() {
    return (
      <div id="product-image-container">
        <Dropzone
          onDrop={this.props.onDrop.bind(this.props.dependentValues.idx, this)}
          className="product-pdf-dropzone"
          // accept="pdf/*"
        > 
        {
          this.props.dependentValues.attachment_id ?
          <span>upload success!</span>
          :
          <Button
            bsStyle="primary"
            type="button"
          >
            <em className="fa fa-upload" />
          <Translate value="upload_pdf" />
          </Button>
        }
        </Dropzone>
      </div>
    );
  },
});

class PdfTableModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [], // idx, name, attachment_id
      filters: null,
      sortColumn: null,
      sortDirection: null,
      
      isLoadingPdfs: false,
      isSavingPdfs: false,
    };
  }

  componentDidMount() {
    this.fetchPdfs();
  }

  fetchPdfs = () => {
    const handleSuccess = (response) => {
      const rows = response;
      rows.map((row, index) => {
        row.idx = index;
      });
      this.setState({ rows, isLoadingPdfs: false });
    };
    const handleFailure = (error) => {
      alert(error);
      this.setState({ isLoadingPdfs: false });
    };
    this.setState({
      isLoadingPdfs: true,
    }, () => getProductPdfs(this.props.productId, handleSuccess, handleFailure));
  }
  
  renderPDF = (index) => {
    const pdfFile = (this.state.rows[index-1].url || '');
    return (
      <div>
        <span>{pdfFile}</span>
      </div>
    );
  }
  
  addPdfRow = (e) => {
    console.log('addPdfRow')
    e.preventDefault();
    let {rows} = this.state;
    const newRow = {
      idx: Number(rows.length) + 1,
      name: '',
      attachment_id: '',
    }
    rows.push(newRow);
    this.setState({ rows });
    // this.setState({
    //   rows: [...this.state.rows, newRow]
    // })
  }
  
  onDrop = (row, files) => {
    if (!files) {
      return;
    }
    
    console.log('row: ', row);
    // get file and convert to blob object (Blob.slice([start [, end [, contentType]]))
    const blob = files[0].slice(0, files[0].size, files[0].type);

    const formData = new FormData();
    formData.append('attachment', blob);
    formData.append('product_id', this.props.productId);
    formData.append('name', files[0].name);
    
    const handleSuccess = (res) => {
      const index = row.props.rowIdx;
      const newRows = [...this.state.rows];
      
      newRows[index].attachment_id = res.id;
      newRows[index].url = res.url;
      newRows[index].name = files[0].name;
      
      this.setState({ rows: newRows });
      // this.setState({
      //   isSavingPdfs: false,
      // }, this.fetchPdfs());
      // this.closeSkusModal();
    };
    
    uploadPdf(formData, handleSuccess);
  }
  
  delPDF = (idx) => {
    let {rows} = this.state;
    rows = rows.filter((obj) => {
      const match = obj.idx !== idx;
      return match;
    });
    rows.map((r,i) => {
      rows[i].idx = i+1;
    });
     this.setState({
      rows
    });
  }

  savePDF = () => {
    let {rows} = this.state;
    console.log('rows: ', rows);
    let tempRows = [];
    rows.map((r,i) => {
      if (r.attachment_id) {
        tempRows.push(r.attachment_id);
      }
    });
    // var str = JSON.stringify(tempRows);
    // this.props.updatePDF(tempRows);
    const handleSuccess = (response) => {
      this.setState({
        isSavingPdfs: false,
      }, this.fetchPdfs());
      // this.closeSkusModal();
    };
    const handleFailure = (error) => {
      let msg = "Error: ";
      msg += JSON.stringify(error);
      alert(msg);
      this.setState({
        isSavingPdfs: false,
      });
    };
    this.setState({
      isSavingPdfs: true,
    }, () => saveProductPdfs(this.props.productId, tempRows, handleSuccess, handleFailure));
  };

  render() {
    
    if (this.state.isLoadingPdfs) {
      return <Spinner />;
    }
    
    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      this.setState(state);
    };

    const onClearFilters = () => {
      this.setState({ filters: {} });
    };

    const handleRowUpdated = (row) => {
      var newRow = this.state.rows;
      let {rows} = this.state;
      let uspTemp = null;
      newRow[row.rowIdx] = {
        ...newRow[row.rowIdx],
        ...row.updated,
      }
      this.setState({
        rows: newRow,
      })
    };

    const columns = [
      {
        key: 'name',
        name: <Translate value="name" />,
        resizable: true,
        width: 180,
        sortable: true,
        filterable: true,
      },
      {
        key: 'attachment_id',
        name: <Translate value="pdf" />,
        resizable: true,
        editable: true,
        width: 180,
        formatter: <PdfFormatter renderPDF={this.renderPDF} onDrop={this.onDrop} />,
        getRowMetaData: row => row,
      },
      {
        key: 'idx',
        name: <Translate value="operation" />,
        resizable: true,
        width: 90,
        formatter: ({ value, dependentValues }) => (
          <div style={{ width: '100%', height: '100%' }}>
            <Button
              bsStyle="danger"
              className="textAlignStyle"
              style={{ height: '23px', width: '39px', padding: '0px' }}
              onClick={() => { this.delPDF(value); }}
            >X
            </Button>
          </div>
      ),
      getRowMetaData: row => row,
      },
    ];

    return (
      <Row>
        <Col sm={12}>
          <ButtonToolbar>
            <Button
              type="button"
              bsStyle="primary"
              onClick={this.addPdfRow}
            >
              <em className="fa fa-plus" /><Translate value="add" />
            </Button>
            <SpinnerButton
              bsStyle="success"
              disabled={this.state.isSavingPdfs}
              onClick={this.savePDF}
              loading={this.state.isSavingPdfs}
              icon="fa-save"
              translation={<Translate value="save" />}
            />
          </ButtonToolbar>
          <div style={{ maxWidth: '100%', marginTop: '5px' }} id="linkProductsModal-dataGrid1">
            <ReactDataGrid
              rowKey="skus_table"
              enableCellSelect
              onRowUpdated={handleRowUpdated}
              rowHeight={25}
              minHeight={250}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
            />
          </div>
        </Col>
      </Row>
    );
  }
}

PdfTableModal.propTypes = propTypes;
PdfTableModal.defaultProps = defaultProps;

export default PdfTableModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/PdfTableModal.jsx